import './certificate-modal.scss';
// front-end/src/components/certificate-modal/certificate-modal.js

export class CertificateModal {
    constructor() {
        this.modal = null;
        this.isOpen = false;
        this.init();
    }

    init() {
        // Настраиваем обработчики событий для всех news-link в сертификатах
        this.setupEventListeners();

        // Обработчик для закрытия по Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.closeModal();
            }
        });

        console.log('[CertificateModal] Инициализирован');
    }

    setupEventListeners() {
        // Используем делегирование событий для динамически добавляемых элементов
        document.addEventListener('click', (e) => {
            // Проверяем, что клик был по news-link в блоке сертификата
            const newsLink = e.target.closest('.news-link');
            if (!newsLink) return;

            // Проверяем, что это именно блок сертификата
            const certificateBlock = newsLink.closest('[data-block-name^="certificate-block-"]');
            if (!certificateBlock) return;

            e.preventDefault();
            e.stopPropagation();

            console.log('[CertificateModal] Клик по news-link в сертификате');
            this.openCertificateModal(certificateBlock);
        });
    }

    async openCertificateModal(certificateBlock) {
        try {
            // Получаем данные о сертификате
            const blockName = certificateBlock.getAttribute('data-block-name');
            const titleElement = certificateBlock.querySelector(`[data-content="${blockName}-title"]`);
            const imageElement = certificateBlock.querySelector(`[data-content="${blockName}-image"]`);

            const title = titleElement ? titleElement.textContent.trim() : 'Сертифікат';
            const imageSrc = imageElement ? imageElement.src : '';

            console.log('[CertificateModal] Открываем модал для:', { blockName, title, imageSrc });

            // Создаем модальное окно
            this.createModal(title, imageSrc, blockName);

            // Показываем модал
            this.showModal();

        } catch (error) {
            console.error('[CertificateModal] Ошибка при открытии модала:', error);
            this.showErrorModal('Помилка завантаження сертифіката');
        }
    }

    createModal(title, imageSrc, blockName) {
        // Удаляем существующий модал если есть
        if (this.modal) {
            this.modal.remove();
        }

        // Создаем новый модал
        this.modal = document.createElement('div');
        this.modal.className = 'certificate-modal-overlay';

        this.modal.innerHTML = `
            <div class="certificate-modal-content">
                <div class="certificate-modal-header">
                    <button class="certificate-modal-close" type="button" aria-label="Закрыть">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#EBFBFF" />
                            <rect x="12.3359" y="11.1611" width="23.3333" height="1.66667" rx="0.833333" transform="rotate(45 12.3359 11.1611)" fill="#009DC9" />
                            <rect x="11.1641" y="27.6602" width="23.3333" height="1.66667" rx="0.833333" transform="rotate(-45 11.1641 27.6602)" fill="#009DC9" />
                        </svg>
                    </button>
                </div>
                <div class="certificate-modal-body">
                    ${this.createModalBodyContent(imageSrc, blockName)}
                </div>
            </div>
        `;

        // Добавляем обработчики
        this.setupModalEventListeners();

        // Добавляем в DOM
        document.body.appendChild(this.modal);
    }

    createModalBodyContent(imageSrc, blockName) {
        if (!imageSrc || imageSrc.includes('placeholder') || imageSrc === '' || imageSrc.endsWith('undefined')) {
            return `
                <div class="certificate-modal-loading">
                    <div class="certificate-modal-spinner"></div>
                    <p>Завантаження зображення...</p>
                </div>
            `;
        }

        return `
            <img class="certificate-modal-image" 
                 src="${imageSrc}" 
                 alt="Сертифікат" 
                 onload="this.style.opacity=1;" 
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<p>Не вдалося завантажити зображення</p>';"
                 style="opacity:0; transition: opacity 0.3s ease;">
        `;
    }

    setupModalEventListeners() {
        if (!this.modal) return;

        const closeBtn = this.modal.querySelector('.certificate-modal-close');
        const overlay = this.modal;

        // Закрытие по клику на крестик
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                this.closeModal();
            });
        }

        // Закрытие по клику на overlay (но не на контент)
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                this.closeModal();
            }
        });

        // Предотвращаем закрытие при клике на контент
        const content = this.modal.querySelector('.certificate-modal-content');
        if (content) {
            content.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    }

    showModal() {
        if (!this.modal) return;

        // Блокируем скролл страницы
        document.body.style.overflow = 'hidden';

        this.isOpen = true;

        // Показываем модал с анимацией
        requestAnimationFrame(() => {
            this.modal.classList.add('active');
        });

        console.log('[CertificateModal] Модал показан');
    }

    closeModal() {
        if (!this.modal || !this.isOpen) return;

        // Разблокируем скролл страницы
        document.body.style.overflow = '';

        this.isOpen = false;

        // Скрываем модал с анимацией
        this.modal.classList.remove('active');

        // Удаляем модал после анимации
        setTimeout(() => {
            if (this.modal) {
                this.modal.remove();
                this.modal = null;
            }
        }, 300);

        console.log('[CertificateModal] Модал закрыт');
    }

    showErrorModal(errorMessage) {
        this.createErrorModal(errorMessage);
        this.showModal();
    }

    createErrorModal(errorMessage) {
        if (this.modal) {
            this.modal.remove();
        }

        this.modal = document.createElement('div');
        this.modal.className = 'certificate-modal-overlay';

        this.modal.innerHTML = `
            <div class="certificate-modal-content">
                <div class="certificate-modal-header">
                    <button class="certificate-modal-close" type="button" aria-label="Закрыть">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#EBFBFF" />
                            <rect x="12.3359" y="11.1611" width="23.3333" height="1.66667" rx="0.833333" transform="rotate(45 12.3359 11.1611)" fill="#009DC9" />
                            <rect x="11.1641" y="27.6602" width="23.3333" height="1.66667" rx="0.833333" transform="rotate(-45 11.1641 27.6602)" fill="#009DC9" />
                        </svg>
                    </button>
                </div>
                <div class="certificate-modal-body">
                    <div class="certificate-modal-error">
                        <div class="certificate-modal-error-icon">⚠️</div>
                        <p>${this.escapeHtml(errorMessage)}</p>
                    </div>
                </div>
            </div>
        `;

        this.setupModalEventListeners();
        document.body.appendChild(this.modal);
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Публичный метод для ручного обновления обработчиков после добавления новых сертификатов
    refreshEventListeners() {
        console.log('[CertificateModal] Event listeners refreshed');
    }

    // Метод для показа модала с конкретным изображением (можно вызвать извне)
    showCertificateImage(title, imageSrc, blockName = 'certificate') {
        this.createModal(title, imageSrc, blockName);
        this.showModal();
    }

    // Метод для проверки, открыт ли модал
    isModalOpen() {
        return this.isOpen;
    }
}

// Создаем глобальный экземпляр
let certificateModalInstance = null;

export function initCertificateModal() {
    if (!certificateModalInstance) {
        certificateModalInstance = new CertificateModal();

        // Делаем доступным глобально для отладки
        window.certificateModal = certificateModalInstance;

        console.log('[CertificateModal] Глобальный экземпляр создан');
    }

    return certificateModalInstance;
}

export function getCertificateModal() {
    return certificateModalInstance;
}

// Функция для показа модала извне
export function showCertificateModal(title, imageSrc, blockName) {
    const modal = getCertificateModal() || initCertificateModal();
    modal.showCertificateImage(title, imageSrc, blockName);
}

// Автоматическая инициализация при загрузке
document.addEventListener('DOMContentLoaded', () => {
    // Небольшая задержка чтобы убедиться что сертификаты загружены
    setTimeout(() => {
        initCertificateModal();
    }, 1000);
});

export default {
    CertificateModal,
    initCertificateModal,
    getCertificateModal,
    showCertificateModal
};